window.onload = () => {
  console.log(123)
  function callFunctionRepeatedly() {
    labels = document.querySelectorAll(".rendered-form label");
    console.log(labels)
    var inputs = document.querySelectorAll(".rendered-form input");
    console.log(inputs)
    var filteredLabels = Array.from(labels).filter(
      (label) => !label.classList.contains("formbuilder-select-label")
    );
    console.log(inputs)
    function updateLabelStyle(input, label) {
      if (input.value.trim() !== "" || input === document.activeElement) {
        label.style.top = "4px";
        label.style.left = "20px";
        label.style.fontSize = "1rem";
        label.style.letterSpacing = ".04rem";

        input.style.padding = "2.2rem 1.5rem .8rem 2rem";
        input.style.margin = "var(--inputs-border-width)";
      } else {
        label.style.top = "10px";
        label.style.left = "20px";
        label.style.fontSize = "1.6rem";
        label.style.letterSpacing = ".1rem";

        input.style.padding = "1.5rem";
        input.style.margin = "var(--inputs-border-width)";
      }
    }

    inputs.forEach((input, index) => {
      input.addEventListener("input", () =>
        updateLabelStyle(input, filteredLabels[index])
      );
      input.addEventListener("focus", () =>
        updateLabelStyle(input, filteredLabels[index])
      );
      input.addEventListener("blur", () =>
        updateLabelStyle(input, filteredLabels[index])
      );
    });
  }
  callFunctionRepeatedly();
};
